module.exports = __webpack_public_path__ + "static/img/bg_cooperation.e6af9dd7.png";